export const downloadImageFromUrl = async (url) => {
  const response = await fetch(url);
  const blob = await response.blob();
  const element = document.createElement('a');
  element.href = URL.createObjectURL(new Blob([blob], { type: 'image/jpeg' }));
  element.download = 'image.jpg';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};
